/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeARightIcon16Light = forwardRef('ArrowShapeARightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.573 7.116a1.25 1.25 0 0 1 0 1.768L8.707 14.75c-.63.63-1.707.184-1.707-.707V12H2.5A1.5 1.5 0 0 1 1 10.5v-5A1.5 1.5 0 0 1 2.5 4H7V1.957C7 1.067 8.077.62 8.707 1.25l5.866 5.866Zm-.707 1.061a.25.25 0 0 0 0-.353L8 1.957V4.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 1 .5.5v2.543l5.866-5.866Z" })));
});
